module.exports = "https://beta.voredev.ru/assets/index/link-blue-6e9cc9204cb168e2e4afe2d9859d799e.svg";